import { render, staticRenderFns } from "./index.vue?vue&type=template&id=77c2db10&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=77c2db10&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c2db10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-pharmacy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77c2db10')) {
      api.createRecord('77c2db10', component.options)
    } else {
      api.reload('77c2db10', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=77c2db10&scoped=true", function () {
      api.rerender('77c2db10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ik/board/chart/bar/stack/IkBarStackChart/index.vue"
export default component.exports